import Colors from "@constants/Colors";
import { Box, Button } from "@mui/material";
import styled from "styled-components";

export const StyledBox = styled(Box)<{ border: string }>`
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  border-bottom: ${({ border }: { border: string }) => border} !important;
  font-family: "Ringside Regular-Book" !important;
  font-weight: 325 !important;
  font-size: 14px !important;
  line-height: 20px !important;
`;

export const StyledButton = styled(Button)<{ disabled: boolean }>`
  text-transform: capitalize !important;
  gap: 4px !important;
  color: ${({ disabled }: { disabled: boolean }) =>
    disabled ? Colors.primarygray_300 : Colors.primary}!important;
  font-family: "Ringside Regular-Bold" !important;
  font-size: 14px !important;
  line-height: 20px !important;
  height: 40px !important;
`;

export const StyledButtonBox = styled(Box)`
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-end !important;
  padding: 0px !important;
`;
